export default [
  'default',
  'light-gray',
  'gray',
  'blue',
  'violet',
  'dark-violet',
  'dark-pink',
  'red',
  'orange',
  'original',
  'yellow',
  'green',
  'teal',
  'white',
];
